import { isMobile } from '@/util/validate'
// 查询大数据
export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  addBtnText: '新增大数据',
  addTitle: '新增大数据',
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchSpan:6,
  searchLabelWidth: 100,
  border: true,
  index: false,
  menu: true,
  indexLabel: '序号',
  selection: false,
  viewBtn: false,
  dialogType: 'dialog',
  saveBtnText: '查询',
  saveBtnIcon: 'none',
  cancelBtnIcon: 'none',
  dialogClickModal: false,
  column: [
    {
      label: '姓名',
      prop: 'name',
      type: 'input',
      search:true,
      searchOrder: 1000,
      minWidth:120,
      rules: [
        {
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }
      ]
    },
    {
      label: '手机号码',
      prop: 'phoneNumber',
      type: 'input',
      search:false,
      searchOrder: 999,
      rules: [
        {
          required: true,
          message: '请输入手机号码',
          trigger: 'blur'
        },
        {
          required: true,
          message: '请输入正确的手机号码',
          validator: (rule, value, callback) => {
            if (!isMobile(value)) {
              return callback(new Error('请输入正确的手机号码'))
            }
            return callback()
          }
        }
      ]
    },
    {
      label: '身份证号',
      prop: 'idNumber',
      type: 'input',
      search:false,
      searchOrder: 999,
      rules: [
        {
          required: true,
          message: '请输入身份证号',
          trigger: 'blur'
        },
        {
          required: true,
          message: '请输入正确的身份证号',
          validator: (rule, value, callback) => {
            const reg = /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/
            if (!reg.test(value)) {
              return callback(new Error('请输入正确的身份证号'))
            }
            return callback()
          }
        }
      ]
    },
    {
      label: '操作人',
      prop: 'account',
      type: 'input',
      search:true,
      display:false,
      searchOrder: 999,
    },
    {
      label: '创建时间',
      prop: 'createTime',
      type: 'input',
      display: false,
      search:false,
      searchOrder: 999,
    },

  ],
};